import { mapState } from 'vuex';
import verifyTab from './components/verifyTab.vue';
import { logOff } from './request.js';
export default {
  components: {
    verifyTab
  },
  props: {
    visibleModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    visible: {
      get() {
        return this.visibleModal;
      },
      set(val) {
        this.$emit('update:visibleModal', val);
      }
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  mounted() {},
  methods: {
    // 确认
    confirmModal() {
      if (this.$refs.verifyRef.activeKey === '1') {
        this.$refs.verifyRef.$refs.ruleForm.validate(async valid => {
          if (valid) {
            this.toLogOff();
          }
        });
      } else {
        this.$refs.verifyRef.$refs.mobileRuleForm.validate(async valid => {
          if (valid) {
            this.toLogOff();
          }
        });
      }
    },
    // 注销
    async toLogOff() {
      let params = {
        way: this.$refs.verifyRef.activeKey,
        //1账号密码 2手机号验证码
        account: this.$refs.verifyRef.activeKey === '1' ? this.accountInfo.account : undefined,
        password: this.$refs.verifyRef.activeKey === '1' ? this.$refs.verifyRef.accountForm.password : undefined,
        mobile: this.$refs.verifyRef.activeKey === '2' ? this.accountInfo.mobile : undefined,
        code: this.$refs.verifyRef.activeKey === '2' ? this.$refs.verifyRef.mobileForm.code : undefined,
        globalRoaming: this.accountInfo.globalRoaming
      };
      let data = await logOff(params);
      if (data) {
        var _this$$router;
        this.$message.success(this.$t('账号注销成功'));
        this.visible = false;
        this.$store.dispatch('user/logout');
        clearInterval(this.$refs.verifyRef.timer);
        await this.$store.dispatch('tagsView/clearTag');
        console.log('this.$router', this.$router);
        (_this$$router = this.$router) === null || _this$$router === void 0 || _this$$router.replace({
          path: '/login'
        });
        sessionStorage.removeItem('loginTime');
        sessionStorage.removeItem('loginRandomId');
      }
    },
    // 取消
    cancleModal() {
      this.visible = false;
    }
  }
};